import graylogClient from '@/core/services/graylog-service';
import globalErrors from '@/core/utils/global-errors';
import { GraylogMessageDTO } from '@/../client-generator/generated-clients/graylog';
import { Vue, Options } from 'vue-class-component';
import { SET_APP_LOADING } from '@/core/store/action-types';

@Options({
  name: 'DialogReportProblem',
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
  },
  watch: {
    isVisible: function (newValue) {
      this.isDialogVisible = newValue;
      this.theMessage = '';
    },
  },
  emits: ['hide-dialog'],
})
export default class DialogReportProblem extends Vue {
  isVisible!: boolean;
  isDialogVisible = false;
  theMessage = '';

  mounted() {
    this.isDialogVisible = this.isVisible;
  }

  handleHideDialog() {
    this.isDialogVisible = false;
  }

  doHideDialog() {
    this.$emit('hide-dialog');
  }

  async sendMessage() {
    const logs = [...globalErrors.getBuffer()];

    this.$store.dispatch(SET_APP_LOADING, true);
    try {
      await graylogClient.log(
        new GraylogMessageDTO({
          userMessage: this.theMessage,
          logs,
          frontendVersion: this.$config.FRONTEND_VERSION,
        })
      );
      this.handleHideDialog();
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.dispatch(SET_APP_LOADING, false);
    }
  }
}
